(function () {
  'use strict';
  const originUrl = new URL(window.location.href);
  const originKey = 'filter.p.m.custom.procurement_origin';
  const clearancePage = /\/collections\/5-or-less\/?$/.test(originUrl.pathname);
  const sizeKey = 'filter.p.m.custom.procurement_size';
  if (clearancePage && originUrl.searchParams.has(sizeKey)) {
    originUrl.searchParams.delete(sizeKey);
    originUrl.searchParams.delete('page');
    window.location.replace(originUrl.toString());
    return;
  }
  const originValues = originUrl.searchParams.getAll(originKey);
  const shortOrigins = originValues.map(value => value.split(',').map(part =>
    part === 'Made in Italy' ? 'Italy' : part === 'Made in China' ? 'China' : part).join(','));
  if (originValues.some((value, index) => value !== shortOrigins[index])) {
    originUrl.searchParams.delete(originKey);
    [...new Set(shortOrigins)].forEach(value => originUrl.searchParams.append(originKey, value));
    originUrl.searchParams.delete('page');
    window.location.replace(originUrl.toString());
    return;
  }
  let openGroup = null;
  let panelOpen = false;
  let timer;
  function root() { return document.querySelector('[data-b2b-procurement]'); }
  function syncCategories(element) {
    if (!element?.hasAttribute('data-b2b-categories')) return;
    const params = new URLSearchParams(window.location.search);
    const query = params.toString();
    const key = 'filter.p.tag';
    const tags = new Set(params.getAll(key).flatMap(value => value.split(',')));
    const inputs = [...element.querySelectorAll('[data-b2b-category]')];
    const selected = inputs.filter(input => input.value.split(',').every(tag => tags.has(tag)));
    const native = document.getElementById('CollectionFiltersForm');
    if (native && native.dataset.b2bCategoryQuery !== query) {
      native.dataset.b2bCategoryQuery = query;
      native.querySelectorAll('[data-b2b-category-hidden]').forEach(input => input.remove());
      // Native price/sort submissions must preserve the complete tag union, even
      // when Shopify's native displayed tag list is capped at 100 values.
      [...tags].forEach(value => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = value;
        input.dataset.b2bCategoryHidden = 'true'; native.append(input);
      });
    }
    if (element.dataset.b2bCategoryQuery === query) return;
    element.dataset.b2bCategoryQuery = query;
    inputs.forEach(input => { input.checked = selected.includes(input); });
    const detail = element.querySelector('[data-b2b-group="filter.p.tag"]');
    detail.classList.toggle('has-selection', selected.length > 0);
    const count = detail.querySelector('[data-b2b-category-count]');
    count.textContent = String(selected.length); count.hidden = !selected.length;
    const total = Number(element.dataset.b2bBaseCount) + selected.length;
    const heading = element.querySelector('[data-b2b-total-selected]');
    heading.textContent = `${total} selected`; heading.hidden = !total;
    element.querySelector('[data-b2b-clear]').disabled = total === 0 && tags.size === 0;
    const chips = element.querySelector('.b2b-active-chips');
    chips.querySelectorAll('[data-b2b-category-chip]').forEach(chip => chip.remove());
    selected.forEach(input => {
      const remaining = new Set(tags);
      input.value.split(',').forEach(tag => remaining.delete(tag));
      const next = new URL(window.location.href);
      next.searchParams.delete(key); next.searchParams.delete('page');
      remaining.forEach(tag => next.searchParams.append(key, tag));
      const chip = document.createElement('a');
      chip.href = next.toString(); chip.dataset.b2bRemove = ''; chip.dataset.b2bCategoryChip = '';
      chip.setAttribute('aria-label', `Remove ${input.dataset.b2bCategory} filter`);
      chip.textContent = `${input.dataset.b2bCategory} `;
      const close = document.createElement('span'); close.textContent = '\u00d7';
      close.setAttribute('aria-hidden', 'true'); chip.append(close); chips.append(chip);
    });
  }
  function syncColourCards(element) {
    const params = new URLSearchParams(window.location.search);
    const colours = params.getAll('filter.v.m.custom.procurement_colour').flatMap(value => value.split(','));
    document.body.classList.toggle('b2b-filter-active', Boolean(element) && [...params].some(([key, value]) => key.startsWith('filter.') && value));
    if (!element || !colours.length) return;
    const min = params.get('filter.v.price.gte');
    const max = params.get('filter.v.price.lte');
    document.querySelectorAll('[data-b2b-variants]').forEach(data => {
      const product = data.closest('.product');
      if (!product || product.dataset.b2bColourSelection === params.toString()) return;
      const variant = JSON.parse(data.textContent).find(value => Array.isArray(value.colours) &&
        value.colours.some(colour => colours.includes(colour)) &&
        (min === null || value.price >= Number(min) * 100) && (max === null || value.price <= Number(max) * 100));
      if (!variant) return;
      const item = product.querySelector('.product-item');
      const swatch = product.querySelector(`.swatch-label[data-variant-id="${variant.id}"]`);
      // Keep native buying controls in sync, but set the image independently of swatch timing.
      if (swatch && window.jQuery && window.jQuery(item).data('json-product')) {
        window.jQuery(swatch).trigger('click', [{skipCardImageUpdate: true}]);
      }
      const image = product.querySelector('.card-media > img:first-child');
      const source = variant.image || (swatch && swatch.dataset.variantImg);
      if (image && source) {
        image.setAttribute('src', source);
        image.setAttribute('srcset', source);
        image.setAttribute('data-srcset', source);
        image.setAttribute('data-src', source);
      }
      product.querySelectorAll('.card-media > a, a.card-title').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        link.href = url.toString();
      });
      if (swatch) {
        product.querySelectorAll('.swatch-label.is-active').forEach(label => label.classList.remove('is-active'));
        swatch.classList.add('is-active');
      }
      product.dataset.b2bColourSelection = params.toString();
    });
  }
  function navigate(params) {
    params.delete('page');
    if (root()?.hasAttribute('data-b2b-categories')) {
      const tags = new Set(params.getAll('filter.p.tag').flatMap(value => value.split(',')));
      params.delete('filter.p.tag');
      tags.forEach(tag => params.append('filter.p.tag', tag));
    }
    const form = root()?.querySelector('[data-b2b-search="true"]');
    if (form) {
      params.set('q', form.elements.namedItem('q').value);
      params.set('type', 'product');
      params.set('options[prefix]', form.elements.namedItem('options[prefix]').value);
      window.location.assign(`${form.action}?${params}`);
      return;
    }
    if (typeof CollectionFiltersForm !== 'undefined') CollectionFiltersForm.renderPage(params.toString(), null);
    else window.location.assign(`${window.location.pathname}?${params}`);
  }
  function applySearchForm(form) {
    clearTimeout(timer);
    const params = new URLSearchParams(window.location.search);
    const managed = new Set([...form.querySelectorAll('[name^="filter."]')].map(input => input.name));
    managed.forEach(key => params.delete(key));
    const data = new FormData(form);
    for (const [key, value] of data) if (key !== 'page' && value !== '') params.append(key, value);
    // Preserve keyword/options once, while retaining repeated multi-select values.
    for (const key of ['q', 'type', 'options[prefix]', 'sort_by']) {
      if (data.has(key)) params.set(key, data.get(key));
    }
    navigate(params);
  }
  function syncSearchPrice(form, changed, commit = false) {
    const min = form.querySelector('[data-b2b-price-input="min"]');
    const max = form.querySelector('[data-b2b-price-input="max"]');
    if (!min || !max) return;
    const side = changed.dataset.b2bPriceRange || changed.dataset.b2bPriceInput;
    const bound = Number(max.max);
    if (changed.dataset.b2bPriceRange || commit) {
      const raw = changed.value === '' ? (side === 'min' ? 0 : bound) : Number(changed.value);
      const value = Math.max(0, Math.min(bound, Math.round(raw)));
      (side === 'min' ? min : max).value = String(value);
      if (Number(min.value) > Number(max.value)) (side === 'min' ? max : min).value = String(value);
    }
    const low = Math.max(0, Math.min(bound, Number(min.value)));
    const high = Math.max(low, Math.min(bound, max.value === '' ? bound : Number(max.value)));
    form.querySelectorAll('[data-b2b-price-range]').forEach(input => {
      input.value = String(input.dataset.b2bPriceRange === 'min' ? low : high);
    });
    const track = form.querySelector('.facets__price--slide');
    track.style.setProperty('--left-space', `${bound ? low / bound * 100 : 0}%`);
    track.style.setProperty('--right-space', `${bound ? (1 - high / bound) * 100 : 0}%`);
  }
  function setPanel(value) {
    panelOpen = value;
    const element = root();
    if (!element) return;
    element.querySelector('[data-b2b-filter-form]').classList.toggle('is-open', value);
    element.querySelector('[data-b2b-open]').setAttribute('aria-expanded', String(value));
    element.querySelector(value ? '[data-b2b-close]' : '[data-b2b-open]').focus();
  }
  function initialize() {
    const element = root();
    document.body.classList.toggle('b2b-procurement-enabled', Boolean(element));
    syncColourCards(element);
    syncCategories(element);
    if (!element || element.dataset.ready) return;
    element.dataset.ready = 'true';
    const searchForm = element.querySelector('[data-b2b-search="true"]');
    const priceMin = searchForm?.querySelector('[data-b2b-price-input="min"]');
    if (priceMin) syncSearchPrice(searchForm, priceMin, true);
    document.querySelectorAll('[data-b2b-sidebar-price]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const min = form.querySelector('[data-b2b-price-input="min"]');
      if (min) syncSearchPrice(form, min, true);
    });
    element.querySelector('[data-b2b-filter-form]').classList.toggle('is-open', panelOpen);
    element.querySelector('[data-b2b-open]').setAttribute('aria-expanded', String(panelOpen));
    element.querySelectorAll('details').forEach(detail => {
      if (detail.dataset.b2bGroup === openGroup) detail.open = true;
      detail.addEventListener('toggle', () => {
        if (!detail.isConnected) return;
        if (detail.open) {
          openGroup = detail.dataset.b2bGroup;
          element.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
        } else if (openGroup === detail.dataset.b2bGroup) openGroup = null;
      });
    });
  }
  document.addEventListener('click', event => {
    const element = root();
    if (!element) return;
    element.querySelectorAll('details[open]').forEach(detail => {
      if (!detail.contains(event.target)) { detail.open = false; if (openGroup === detail.dataset.b2bGroup) openGroup = null; }
    });
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-b2b-filter-form],[data-b2b-sidebar-price]');
    if (form?.dataset.b2bSearch === 'true' && event.target.matches('[data-b2b-price-input]')) {
      syncSearchPrice(form, event.target, true);
      return;
    }
    if (!form || event.target.type !== 'checkbox') return;
    const params = new URLSearchParams(window.location.search);
    form.querySelectorAll('[data-b2b-group]').forEach(detail => params.delete(detail.dataset.b2bGroup));
    form.querySelectorAll('input[type=checkbox]:checked').forEach(input => params.append(input.name, input.value));
    clearTimeout(timer);
    timer = setTimeout(() => navigate(params), 250);
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-b2b-price-range],[data-b2b-price-input]')) return;
    const form = event.target.closest('[data-b2b-search="true"]');
    if (form) syncSearchPrice(form, event.target);
  });
  document.addEventListener('click', event => {
    const applyPrice = event.target.closest('[data-b2b-price-apply]');
    if (applyPrice) applySearchForm(applyPrice.closest('form'));
    if (event.target.closest('[data-b2b-open]')) setPanel(true);
    if (event.target.closest('[data-b2b-close]')) setPanel(false);
    const clear = event.target.closest('[data-b2b-clear]');
    if (clear && !clear.disabled) {
      clearTimeout(timer);
      const params = new URLSearchParams(window.location.search);
      [...new Set(params.keys())].filter(key => key.startsWith('filter.')).forEach(key => params.delete(key));
      openGroup = null;
      navigate(params);
    }
    const chip = event.target.closest('[data-b2b-remove]');
    if (chip) { event.preventDefault(); clearTimeout(timer); navigate(new URL(chip.href).searchParams); }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-b2b-filter-form],[data-b2b-sidebar-price]');
    if (form) {
      event.preventDefault();
      if (form.dataset.b2bSearch === 'true') applySearchForm(form);
      if (form.matches('[data-b2b-filter-form]')) setPanel(false);
    }
  });
  document.addEventListener('keydown', event => {
    const element = root();
    if (!element) return;
    if (event.key === 'Escape') {
      element.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
      openGroup = null;
      if (panelOpen) setPanel(false);
    }
    if (event.key === 'Tab' && panelOpen) {
      const controls = [...element.querySelectorAll('button:not(:disabled),summary,input:not(:disabled)')].filter(control => control.getClientRects().length);
      const first = controls[0], last = controls[controls.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  initialize();
  document.addEventListener('DOMContentLoaded', initialize);
  const grid = document.getElementById('CollectionProductGrid');
  if (grid) new MutationObserver(initialize).observe(grid, {childList:true,subtree:true});
})();
